export function validateEmail(mail): boolean {
  return /^[^@]+@\w+(\.\w+)+\w$/.test(mail)
}
